import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './promo-page-starting-popup.scss';
const PromoPageStartingPopup = ({
  onClose,
  title,
  description,
  isOpen = false
}) => /*#__PURE__*/React.createElement(PopupDialog, {
  open: isOpen,
  onClose: onClose,
  title: renderTitle(title),
  content: renderContent(description, onClose),
  showCloseButton: true
});
const renderTitle = title => /*#__PURE__*/React.createElement("div", {
  className: classes.title
}, title);
const renderContent = (description, onClose) => /*#__PURE__*/React.createElement("div", {
  className: classes.contentWrapper
}, /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement(Button, {
  className: classes.closeButton,
  type: "starter",
  size: "long",
  onClick: onClose
}, "Close"));
export default PromoPageStartingPopup;